export default __webpack_public_path__ + "static/media/matching-icon.8ff812d5.svg";